import {PewComponent} from "./pew-component";
import {Menu} from "./menu";

class headerComponent extends PewComponent {

  constructor(element, options) {
    let defaultOptions = {
      'classToToggleOnBody': 'has-opened-menu'
    };
    super(element, Object.assign(defaultOptions, options));
    this.menu = null;
  }

  init() {
    this.registerMenuToggler();
    this.registerFixHeader();
  }

  registerMenuToggler() {
    this.element.find('[data-menu-toggler]').on('click', (e) => {
      e.preventDefault();
      if (!window.matchMedia("(min-width: 769px)").matches) {
        if (this.menu === null) {
          this.menu = new Menu(this.element.find('.navigation-wrapper'));
          this.element.data('headerComponent', this);
        }
      }
      if (this.menu.opened) {
        //close
        this.closeMenu();
      } else {
        $(e.currentTarget).addClass('is-active');
        $('body').addClass(this.options.classToToggleOnBody);
        this.menu.open();
      }
    });
  }

  closeMenu() {
    this.menu.close(() => {
      $('[data-menu-toggler]').removeClass('is-active');
      $('body').removeClass(this.options.classToToggleOnBody);
    });
  }

  registerFixHeader() {
    window.onscroll = function () {checkHeaderFixation()};

    var header = document.getElementById("header");
    var sticky = header.offsetTop + 50;

    function checkHeaderFixation() {
      if (window.pageYOffset > sticky) {
        document.body.classList.add("is-sticky");
      } else {
        document.body.classList.remove("is-sticky");
      }
    }
  }

}

window.pew.addRegistryEntry({key: 'header', domSelector: '#header', classDef: headerComponent});
